import { z } from 'zod';
import { isoDateSchema } from './subscription.js';
// ---------------------------------------------------------------------------
// The cabinet's trial read (registration-approval arch §6, ADR-044).
//
// A new player read on purpose: `GET /player/me` is frozen (ADR-038), and a
// field added to it would be rejected by every bundle already running on a
// venue tablet. An old bundle never calls this route, so it keeps working.
// ---------------------------------------------------------------------------
/**
 * `GET /player/trial` (`@PlayerAuth()`). The state is derived on the server
 * from the subscription of the token's venue (`venues.subscription_id`, the row
 * the playback gate reads) against the server's today, the UTC date:
 *   - `running` — status `trial` and `period_end` after today;
 *   - `ended`   — status `trial` and `period_end` on or before today; the music
 *     still plays until a manager stops the trial (ADR-044);
 *   - `none`    — not a trial: paid, paused, stopped or missing. «Кабинет» keeps
 *     its rows from `GET /player/me`.
 *
 * `last_day` is set only for `running`: the last day the trial covers,
 * `period_end` − 1, computed on the server — «Пробный период до {last_day}
 * включительно». The player renders it and does no date arithmetic (N-12).
 * `null` for `ended` and `none`.
 */
export const playerTrialResponseSchema = z
    .object({
    state: z.enum(['none', 'running', 'ended']),
    last_day: isoDateSchema.nullable(),
})
    .strict();
//# sourceMappingURL=player-trial.js.map